import { __read } from "tslib";
var EuropeanCountryCodes = [
    ['ALB', 'AL', 'AL'],
    ['AUT', 'AT', 'AT'],
    ['BEL', 'BE', 'BE'],
    ['BGR', 'BG', 'BG'],
    ['CHE', 'CH', 'CH'],
    ['CYP', 'CY', 'CY'],
    ['CZE', 'CZ', 'CZ'],
    ['DEU', 'DE', 'DE'],
    ['DNK', 'DK', 'DK'],
    ['EST', 'EE', 'EE'],
    ['GRC', 'GR', 'EL'],
    ['ESP', 'ES', 'ES'],
    ['FIN', 'FI', 'FI'],
    ['FRA', 'FR', 'FR'],
    ['HRV', 'HR', 'HR'],
    ['HUN', 'HU', 'HU'],
    ['IRL', 'IE', 'IE'],
    ['ISL', 'IS', 'IS'],
    ['ITA', 'IT', 'IT'],
    ['LIE', 'LI', 'LI'],
    ['LTU', 'LT', 'LT'],
    ['LUX', 'LU', 'LU'],
    ['LVA', 'LV', 'LV'],
    ['MLT', 'MT', 'MT'],
    ['MKD', 'MK', 'MK'],
    ['NLD', 'NL', 'NL'],
    ['NOR', 'NO', 'NO'],
    ['PRT', 'PT', 'PT'],
    ['POL', 'PL', 'PL'],
    ['ROU', 'RO', 'RO'],
    ['SCG', 'CS', 'RS'],
    ['SWE', 'SE', 'SE'],
    ['SVN', 'SI', 'SI'],
    ['SVK', 'SK', 'SK'],
    ['TUR', 'TR', 'TR'],
    ['GBR', 'GB', 'UK'], // United Kingdom
];
export function nutsByCountryCode(threeLetterCountryCode) {
    if (!threeLetterCountryCode || threeLetterCountryCode.length !== 3) {
        return null;
    }
    var country = EuropeanCountryCodes.find(function (_a) {
        var _b = __read(_a, 1), iso3Code = _b[0];
        return iso3Code === threeLetterCountryCode;
    });
    return country ? country[2] : null;
}
